import React, { useState, useEffect } from 'react';
import { Col, CardBody } from 'reactstrap';
import moment from 'moment';
import Spinner from 'react-bootstrap/Spinner';
import DataReactTableReceiptsList from './DataReactTableReceiptsList';
import { formatNumber } from '../../../Utils/Money';

const ReceiptsList = () => {

    const [load, setLoad] = useState(true);
    const [receipts, setReceipts] = useState([]);

    useEffect(() => {
        loadReceipts();
    }, []);

    const getAdmision = (id_admsion) => {
        return new Promise((resolve, reject) => {
            var data = {
                id_admision: parseInt(id_admsion),
                id_historia: 0,
                num_documento: "0",
                fecha: "0"
            };
            console.log(data);
            fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            }).then(response => {
                return response.json();
            }).then(data => {
                let dataAdmisionFiltered = filterDataPatient(data.contenido);
                resolve(dataAdmisionFiltered);
            }).catch((error) => {
                console.error('Error:', error);
                reject(error);
            });
        });
    }

    const filterDataPatient = (data) => {
        console.log("COMINGTOFILTER", data)
        let orderData = [];
        for (let i = 0; i < data.length; i++) {
            let serNombre = "";
            if (data[i].servicio.servicios.length > 1) {
                for (let k = 0; k < data[i].servicio.servicios.length; k++) {
                    if (data[i].servicio.servicios[k].codigo != null && data[i].servicio.servicios[k].codigo != undefined) {
                        serNombre += data[i].servicio.servicios[k].codigo;
                        if (k < data[i].servicio.servicios.length - 1) {
                            serNombre += " - ";
                        }
                    }
                    else if (data[i].servicio.servicios[k].cupscod != null && data[i].servicio.servicios[k].cupscod != undefined) {
                        serNombre += data[i].servicio.servicios[k].cupscod;
                        if (k < data[i].servicio.servicios.length - 1) {
                            serNombre += " - ";
                        }
                    }
                }
            }
            else {
                serNombre = data[i].servicio.servicios[0] != undefined ? data[i].servicio.servicios[0].nombre : "";
            }

            let caidasAdm = null;

            if (data[i].caidas != null) {
                caidasAdm = data[i].caidas;
            }
            else if (data[i].caidas_cita != null) {
                caidasAdm = data[i].caidas_cita;
            }
            else {
                caidasAdm = null;
            }

            orderData[i] = {
                num_documento: data[i].num_documento,
                fullname: data[i].apellido2 != null ? data[i].nombres + " " + data[i].apellido1 + " " + data[i].apellido2 : data[i].nombres + " " + data[i].apellido1,
                tip_documento: data[i].tip_documento,
                fecha: data[i].fecha,
                birthday: data[i].fec_nacimiento,
                id_admision: data[i].id_admision,
                hora: data[i].hora,
                id_historia: data[i].id_historia,
                id_paciente: data[i].id_paciente,
                direccion: data[i].direccion,
                notas: data[i].notas,
                id_cita: data[i].id_cita,
                correctos: data[i].correctos,
                estado: data[i].estado,
                archivos: data[i].archivos,
                caidas: caidasAdm,
                pertenece_estudio: data[i].pertenece_estudio,
                servicios: data[i].pertenece_estudio ? data[i].estudio_detalle.detalle.visita : data[i].servicio.servicios,
                servName: data[i].pertenece_estudio ? data[i].estudio_detalle.detalle.visita.nombre : serNombre,
                celular: data[i].celular,
                telefono: data[i].telefono1,
                correo: data[i].correo,
                direccion: data[i].direccion !== null ? data[i].direccion.direccion : "",
                id_visita: data[i].estudio_detalle != null ? data[i].estudio_detalle.detalle.visita.id_visita : null,
                id_estudio: data[i].estudio_detalle != null ? data[i].estudio_detalle.detalle.estudio_clinico.id_estudio : null,
                estado_imagenes: data[i].estado_imagenes != null ? data[i].estado_imagenes : null,
                estado_medico: data[i].estado_medico != null ? data[i].estado_medico : null,
                fecha_ingreso_completa: data[i].fecha_ingreso_completa != null ? moment(data[i].fecha_ingreso_completa).format('h:mm:ss a') : null,
                fecha_cita: data[i].fecha_cita != null ? moment(data[i].fecha_cita).format('h:mm:ss a') : null,
                destacar: false,
                pago: data[i].recibo_pago,
                remitente: data[i].remitente,
                peso: data[i].peso,
                talla: data[i].talla,
                id_tecnologo: data[i].tecnologo,
                id_usuario_profesional: data[i].id_usuario_profesional,
                existen_imagenes_diagnosticas: validateDiagnosticImages(data[i].archivos),
                requerimientos_especiales: data[i].requerimientos_especiales,
                correctos: data[i].correctos,
                id_tercero: data[i].id_tercero,
                nombre_tercero: data[i].nombre_tercero,
                nit_tercero: data[i].nit_tercero,
                telefono_tercero: data[i].telefono_tercero,
                correo_tercero: data[i].correo_tercero,
                direccion_tercero: data[i].direccion_tercero,
                entrevista_realizada: data[i].entrevista_realizada,
                radiofarmaco_aplicado: data[i].radiofarmaco_aplicado,
                canalizacion_radiofarmaco: data[i].canalizacion_radiofarmaco
            }
        }

        let admisionData = orderData;

        return admisionData;
    }

    const validateDiagnosticImages = (dataFiles) => {
        console.log(dataFiles);
        if (dataFiles != undefined && dataFiles != null) {
            return true;
        } else {
            return false;
        }
    }

    const loadReceipts = async () => {
        setLoad(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        }).then(response => {
            return response.json();
        }).then(data => {
            console.log(data);
            //filterData(data);
            setReceipts(data);
            setLoad(false);
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    const filterData = (data) => {
        for (let i = 0; i < data.length; i++) {
            data[i].fecha_format = moment(data[i].fecha_format).format('YYYY-MM-DD');
        }
        setReceipts(data);
    }

    const reactTableData = {
        tableHeaderData: [{
            Header: 'RECIBO N°',
            accessor: 'num_recibo',
            width: 65,
            Cell: row => (
                <label>
                    {(row.value)}
                </label>
            )
        },
        {
            Header: 'ADMISIÓN',
            accessor: 'id_admision',
            Cell: row => (
                <label>
                    {(!!row.row.original.id_admision ? row.row.original.id_admision : '' )}
                </label>
            )
        },
        {
            Header: 'FECHA',
            accessor: 'fecha',
            Cell: row => (
                <label>{row.value != null && row.value != undefined ? moment(row.value).format("YYYY/MM/DD") : null}</label>
            )
        },
        {
            Header: 'CLIENTE',
            accessor: 'nombre_paciente',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: 'TIPO DE PAGO',
            accessor: 'tipo_pago',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: 'ESTADO DEL RECIBO',
            accessor: 'recibo_cancelado',
            Cell: row => (
                <label>{row.value == true ? "ANULADO" : "ACTIVO"}</label>
            )
        },
        {
            Header: 'TOTAL',
            accessor: 'total',
            Cell: row => (
                <label>
                    ${formatNumber(parseInt(row.value))}
                </label>
            )
        }
        ],
        tableRowsData: receipts
    };

    const ListReceipts = () => {
        return (<DataReactTableReceiptsList title={'Recibos de Caja'} reactTableData={reactTableData} loadReceipts={loadReceipts} getAdmision={getAdmision} />);
    }

    return (
        <CardBody>
            <Col>
                {!load ? <ListReceipts /> : <div style={{display: 'flex', flexDirection: 'row',  justifyContent: 'center' }}><Spinner style={{ color: '#4ce1b6' }} animation="border" /></div>}
            </Col>
        </CardBody>
    );

}
export default ReceiptsList;